module.exports = "/_next/static/images/ico-bon-plan-8ab0f2024c43a9033689adaea72ee5d5.svg";